<template>
  <header class="card-header main-header">
    <div class="row h-100">
      <div class="col-lg-2 visao-container" v-if="filtros.visao && filtros.visao.length">
        <select class="form-control pre-filtro" @change="handleTrocarVisao()" v-model="filtros.visaoSelecionada">
          <optgroup label="Padrão">
            <template v-for="f in filtros.visao">
              <option :key="'p'+f.id" :value="f.id">{{ f.title }}</option>
            </template>
          </optgroup>
          <optgroup label="Minhas visões" v-if="filtros.visaoCustom && filtros.visaoCustom.length">
            <template v-for="f in filtros.visaoCustom">
              <option :key="'c'+f.Id" :value="'c'+f.Id">{{ f.Nome }}</option>
            </template>
          </optgroup>
        </select>
        <button type="button"
                v-if="permiteSalvarVisao"
                class="btn btn-sm btn-link visao-action"
                title="Salvar filtros atuais como visão"
                @click="$emit('abrir-salvar-visao')">
          <i class="fas fa-star"></i>
        </button>
        <button type="button"
                v-if="permiteSalvarVisao && visaoCustomSelecionada"
                class="btn btn-sm btn-link visao-action text-danger"
                title="Excluir esta visão"
                @click="excluirVisaoCustom">
          <i class="far fa-trash-alt"></i>
        </button>
      </div>
      <div :class="'col-lg-'+(filtros.visao && filtros.visao.length ? '6' : '8')">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="card-title" v-if="itemSelecionado.length && itemSelecionado[0].Id !== 0">
              <slot name="header" :itemSelecionado="itemSelecionado"></slot>
              <slot name="subheader" :params="params"></slot>
            </h2>
          </div>
          <div class="col-lg-6">
            <slot name="desc"></slot>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card-actions">
          <slot name="buttons" :params="params" :itemSelecionado="itemSelecionado"></slot>
          <template v-for="btn in actionButtons.filter(b => b.className.includes('padrao'))">
            <button v-if="btn.visible"
                    :key="btn.id"
                    :class="btn.className + ' btn btn-sm btn-'+btn.color"
                    @click="btn.callback"
                    :title="btn.title">
              <i 
                 v-if="btn.icon"
                 :style="{color: btn.iconColor || 'inherit'}"
                 :class="btn.icon"></i> {{btn.text}}
            </button>
          </template>
          
        </div>
      </div>
    </div>
  </header>
</template>

<script>

//DATAHEADER
export default {
    props: {
        handleTrocarVisao: {},
        filtros: {},
        itemSelecionado: {},
        actionButtons: {},
        params: {},
        excluirVisaoCustom: {},
        permiteSalvarVisao: { type: Boolean, default: false }
    },
    computed: {
        visaoCustomSelecionada() {
            let sel = this.filtros.visaoSelecionada;
            return typeof sel === 'string' && sel.charAt(0) === 'c';
        }
    }
};
</script>

